// Generated by pnpm narration:generate from narrationConfig.json.
export { default } from '../../public/narration/production/workflow/en-US-Neural2-J/manifest.json';
